<template>
	<NuxtLoadingIndicator color="repeating-linear-gradient(to right, #8FDBFF 0%, #2FB0FF 50%, #1A4FCF 100%)" />

	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
</template>

<script setup>
import useAuthStore from '~/store/auth'
import useConfigStore from '~/store/config'
import useSocketStore from '~/store/socket'

const authStore = useAuthStore()
const configStore = useConfigStore()
const socketStore = useSocketStore()

const baseURL = useRuntimeConfig().public.apiBase

await callOnce(async () => {
	try {
		if (!authStore.user) {
			return
		}

		configStore.languages = await $fetch('/languages', {
			baseURL,
			headers: {
				Authorization: `Bearer ${authStore.token}`
			}
		})

		configStore.selectedLanguage = configStore.languages?.[0]?.id
	} catch (error) {
		console.error
	}
})

onNuxtReady(() => {
	if (!authStore.user) {
		return
	}

	socketStore.initialize()
})

const FAVICON_VERSION = 'boxy2'

useHead({
	titleTemplate: (titleChunk) => (titleChunk ? `${titleChunk} | Boxy` : 'Boxy'),
	// ?v= — prehliadače držia favicon v cache natvrdo (stará ikona Planets), nová URL ich prinúti stiahnuť Boxy.
	link: [
		{ rel: 'icon', href: `/favicon.ico?v=${FAVICON_VERSION}`, sizes: '32x32' },
		{ rel: 'icon', type: 'image/png', sizes: '32x32', href: `/favicon-32.png?v=${FAVICON_VERSION}` },
		{ rel: 'icon', type: 'image/png', sizes: '192x192', href: `/favicon-192.png?v=${FAVICON_VERSION}` },
		{ rel: 'icon', type: 'image/svg+xml', href: `/boxy-favicon.svg?v=${FAVICON_VERSION}` },
		{ rel: 'apple-touch-icon', href: `/apple-touch-icon.png?v=${FAVICON_VERSION}` }
	]
})
</script>
